import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ModalConfirmContentComponent, ModalConfirmService } from "./confirm-window";
import { ModalAlertComponent, ModalAlertService } from "./alert-window";
import { ModalEnviaEmailComponent, ModalEnviaEmailService } from "./envia-email-window";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";


@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    declarations: [
        ModalConfirmContentComponent,
        ModalConfirmService,
        ModalAlertComponent,
        ModalAlertService,
        ModalEnviaEmailComponent,
        ModalEnviaEmailService
    ],
    entryComponents: [ModalConfirmContentComponent, ModalAlertComponent, ModalEnviaEmailComponent],
    exports: [ModalConfirmContentComponent, ModalAlertComponent, ModalEnviaEmailComponent]
})
export class RessarcimentoWindowModule {

    static forRoot() {
        return {
            ngModule: RessarcimentoWindowModule,
            providers: [ModalConfirmService, ModalAlertService, ModalEnviaEmailService]
        }

    }
}